/** @format */

import {Box} from '@mui/material';
import {styled} from '@mui/material/styles';

import {Container as BaseContainer} from '../AdSystemConnectBlock/styles';

export {
  ContentRow,
  InstructionBlock,
  InstructionText,
  EmergencyIcon,
  SafetyBlock,
  SafetyTextColumn,
  SafetyTitle,
  SafetyText,
  SafetyIconWrapper,
  ConnectButton,
  ButtonIcon,
} from '../AdSystemConnectBlock/styles';

export const Container = styled(BaseContainer)(({theme}) => ({
  marginTop: theme.spacing(4),
}));

export const HelpAccordion = styled(Box, {
  shouldForwardProp: prop => prop !== 'isExpanded',
})<{isExpanded: boolean}>(({theme, isExpanded}) => ({
  backgroundColor: isExpanded
    ? theme.palette.semantic_dark?.surface.surface1
    : theme.palette.semantic_dark?.surface.surface2,
  borderRadius: '8px',
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  transition: 'background-color 0.3s ease',
}));

export const HelpHeader = styled(Box)(({theme}) => ({
  backgroundColor: theme.palette.semantic_dark?.primary.container,
  borderRadius: '8px',
  display: 'flex',
  alignItems: 'center',
  cursor: 'pointer',
  width: '100%',
}));

export const HelpHeaderTitle = styled(Box)(({theme}) => ({
  flex: '1 0 0',
  fontSize: '16px',
  fontWeight: 600,
  lineHeight: '20px',
  letterSpacing: '0.16px',
  color: theme.palette.semantic_dark?.primary.main,
  paddingLeft: theme.spacing(4),
  paddingRight: theme.spacing(2),
  display: 'flex',
  alignItems: 'center',
  alignSelf: 'stretch',
}));

export const HelpDropdownIcon = styled(Box)(({theme}) => ({
  fontSize: '20px',
  color: theme.palette.semantic_dark?.surface.onSurface,
  lineHeight: 1,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(3.5, 4),
  borderRadius: '8px',
  flexShrink: 0,
}));

export const HelpContent = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  padding: theme.spacing(4),
  overflow: 'hidden',
}));

export const NumberedList = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  color: theme.palette.semantic_dark?.surface.onSurface,
  width: '100%',
}));

export const NumberedListItem = styled(Box)(({theme}) => ({
  display: 'flex',
  gap: theme.spacing(2),
  alignItems: 'flex-start',
  borderRadius: '8px',
  width: '100%',
}));

export const NumberedListIcon = styled(Box)({
  fontSize: '20px',
  lineHeight: 1,
  flexShrink: 0,
});

export const NumberedListText = styled(Box)({
  flex: '1 0 0',
  fontSize: '16px',
  fontWeight: 400,
  lineHeight: '20px',
});

export const HelpEmergencyBlock = styled(Box)(({theme}) => ({
  display: 'flex',
  gap: theme.spacing(2),
  alignItems: 'flex-start',
  paddingTop: theme.spacing(4),
  width: '100%',
}));

export const HelpEmergencyTextColumn = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: theme.spacing(2),
}));

export const HelpEmergencyText = styled(Box)(({theme}) => ({
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '16px',
  color: theme.palette.semantic_dark?.surface.onSurface,
}));

export const ReportAnalyticsButton = styled(Box)(({theme}) => ({
  border: `1px solid ${theme.palette.semantic_dark?.surface.onSurfaceMuted}`,
  borderRadius: '8px',
  padding: theme.spacing(2, 4),
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '16px',
  color: theme.palette.semantic_dark?.surface.onSurface,
  cursor: 'pointer',
  flexShrink: 0,
  userSelect: 'none',
}));
